import React, { useEffect, useMemo, useState } from 'react'
import { FaPlus } from 'react-icons/fa6'
import PadContainer from '../../../../components/PadContainer'
import TitleContainer from '../../../../components/TitleContainer'
import { Avatar, Button, Divider, Drawer, Dropdown, Form, Image, Input, Modal, Select, Space, Tag, Tooltip, Upload } from 'antd'
import { UploadOutlined } from '@ant-design/icons';
import eventImage from '../../../../assets/gallery/event.png'
import { formatCurrency, handleConfirm, handleTableSelect, statusType } from '../../../../context/utils'
import CustomTable from '../../../../components/CustomTable'
import { PiDotsThreeOutlineBold } from 'react-icons/pi'
import { BiEdit } from 'react-icons/bi'
import { LuFileUp } from 'react-icons/lu'
import { GoTrash } from 'react-icons/go'
import { ImStopwatch } from 'react-icons/im'
import { CiCalendarDate, CiLocationOn } from 'react-icons/ci'
import { useGetProducts } from '../../../../hooks/products/products'
import SearchPage from '../../../../components/searchPage'
import { useAddDevice, useAddDevices, useDeleteDevice, useGetAllInsureDevices, useGetInsuranceDevice, usePatchDevice } from '../../../../hooks/insuredCompany/insuredCompany'


function InsuredDevice() {
  const [productType, setProductType] = useState("")
  const [isCreateOpen, setIsCreateOpen] = useState(false)
  const [isViewOpen, setIsViewOpen] = useState(false)
  const [image, setImage] = useState(null)
  const [search, setSearch] = useState('')
  const [page, setPage] = useState(0)
  const onCreateOpen = () => setIsCreateOpen(true)
  const onViewClose = () => setIsViewOpen(false)
//   const onViewOpen = () => setIsViewOpen(true)
  const [isOpenEdit, setIsOpenEdit] = useState(false)
  const onOpenEdit = () => setIsOpenEdit(true)
  const [rows, setRows] = useState([])
  const width = window.innerWidth
  const isMobile = width <= 500
  const [form] = Form.useForm()
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };

  const onCreateClose = () => {
    form.resetFields()
    setIsCreateOpen(false)
    setRows([])
  }
  
  const onCloseEdit = () => {
    setIsOpenEdit(false)
    form.resetFields();
    setProductType("")
  }
   
  const [createPayload, setCreatePayload] = useState({
    firstName: "",
    lastName: "",
    price: 0,
    imeiNumber1: "",
    imeiNumber2: "",
    receiptImageUrl: "",
    serialNumber: "",
    model: "",
    status: "",
    productType: "",
    brand: ""
  })

  const {
    data: getAllData,
    refetch: getFetch,
    isFetching: getAllLoad,
  } = useGetAllInsureDevices(    
    { pageNumber:page, searchString: search },
    ["pageNumber", "searchString"],
  )

  const {
    data: getProductsData,
    isFetching: getProductsLoad,
  } = useGetProducts()

const {
  data: getData,
  mutate: getAction,
  isLoading: getLoad,
} = useGetInsuranceDevice(onOpenEdit)

// const {
//   data: getExcel,
//   isFetching: getExcelLoad,
// } = useGetExcel()


  const successAction = () => {
    form.resetFields();
    onCreateClose();
    onCloseEdit();
    getFetch();
  };

  useEffect(() => {
    const { id, firstName, lastName, price, imeiNumber1, imeiNumber2, receiptImageUrl, serialNumber, model, status, productType: prodType, brand } = getData?.data || {}
    form.setFieldsValue({ firstName, lastName, price, imeiNumber1, imeiNumber2, receiptImageUrl, serialNumber, model, status, productType: prodType, brand })
    setCreatePayload({
      id: id || "",
      firstName: firstName || "",
      lastName: lastName || "",
      price: price || "",
      imeiNumber1: imeiNumber1 || "",
      imeiNumber2: imeiNumber2 || "",
      receiptImageUrl: receiptImageUrl || "",
      serialNumber: serialNumber || "",
      model: model || "",
      status: status || "",
      productType: prodType || "",
      brand: brand || ""
    })
    setProductType(prodType || "")
  }, [getData?.data])

  const uploadProps = useMemo(() => ({
    name: 'file',
    method: 'GET',
    multiple: false,
    data: image?.file,
    onChange({file, fileList}) {
      setImage({
        file,
        name: file?.name,
        fileObj: file?.originFileObj,
        url: URL.createObjectURL(file?.originFileObj),
      })
      // setCreatePayload({...createPayload, imageFile: file?.originFileObj})
    }
  }), [image]);

  const {
    mutate: postAction,
    isLoading: postLoad,
  } = useAddDevice(successAction)

  const {
    mutate: postExcel,
    isLoading: postExcelLoad,
  } = useAddDevices(successAction)

  const {
    mutate: putAction,
    isLoading: putLoad,
  } = usePatchDevice(successAction)

  
  const {
    mutate: deleteAction,
    isLoading: deleteLoad,
  } = useDeleteDevice(successAction)

  const handleEdit = (d) => {    
    getAction(d.id)
  }


  const columns = [
    {
      title: "Name",
      key:"1",
      render: (e) => <div className='flex items-center gap-3'>
        <Avatar src="">{e?.firstName?.charAt(0)}{e?.lastName?.charAt(0)}</Avatar>
        <p className='text-sm font-medium text-dim'>{e?.firstName} {e?.lastName}</p>
      </div>,
    },
    {
      title: "Brand",
      dataIndex: "brand",
      key:"brand",
      render: (e) => <div className='flex items-center gap-3'>
        <p className='text-sm font-medium text-dim'>{e}</p>
      </div>,
    },
    {
      title: "Model",
      dataIndex: "model",
      key:"2",
      render: (e) => <div className='flex items-center gap-3'>
        <p className='text-sm font-medium text-dim'>{e}</p>
      </div>,
    },
    {
      title: "Product Type",
      dataIndex: "productType",
      key:"6",
      render: (e) => <div className='flex items-center gap-3'>
        <p className='text-sm font-medium text-dim'>{e}</p>
      </div>,
    },
    {
      title: "Price",
      dataIndex: "price",
      key:"3",
      render: (e) => <div className='flex items-center gap-3'>
        <p className='text-sm font-medium text-dim'>{formatCurrency(e)}</p>
      </div>,
    },
    {
      title: "Serial Number",
      dataIndex: "serialNumber",
      key:"serialNumber",
      render: (e) => <div className='flex items-center gap-3'>
        <p className='text-sm font-medium text-dim'>{e}</p>
      </div>,
    },
    {
      title: "Imei Number 1",
      dataIndex: "imeiNumber1",
      key:"imeiNumber1",
      render: (e) => <div className='flex items-center gap-3'>
        <p className='text-sm font-medium text-dim'>{e}</p>
      </div>,
    },
    {
      title: "Imei Number 2",
      dataIndex: "imeiNumber2",
      key:"imeiNumber2",
      render: (e) => <div className='flex items-center gap-3'>
        <p className='text-sm font-medium text-dim'>{e}</p>
      </div>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key:"4",
      render: (e) => 
      <Tag className={`{${e} ? ${statusType?.active?.col} : ${statusType?.inactive?.col}} ${e} ? ${statusType?.active?.bd} : ${statusType?.inactive?.bd}} font-bold rounded-2xl px-3 py-0.5`}>{e ? "ACTIVE" : "INACTIVE"}</Tag>
    },
    // {
    //   title: "Receipt",
    //   dataIndex: "receiptImageUrl",
    //   key:"5",
    //   render: (e) => 
    //     <Image src={e} alt='vRV' width={70} />
    // },
    {
      title: "Action",
      dataIndex: "",
      render: (data,idx) => <Dropdown
        key={idx}
        trigger={["click"]}
        placement="bottomRight"
        menu={{items: [
          {key: "edit", label: <button className='flex' onClick={()=>handleEdit(data)}><BiEdit className='!text-base my-auto' /> Edit</button>},
          {key: "delete", label: <button onClick={() => handleConfirm({data: data?.id, action: deleteAction})}><GoTrash className='!text-base py-auto' /> Delete</button>},
        ]}}
      >
        <Button loading={getLoad || deleteLoad} className='!bg-[#F2F6FC]' type='text' icon={<PiDotsThreeOutlineBold />} />
      </Dropdown>
    },
  ]
  const onSubmit = (d) => {
    const payload = {
        firstName: d.firstName,
        lastName: d.lastName,
        price: d.price,
        imeiNumber1: d.imeiNumber1,
        imeiNumber2: d.imeiNumber2,
        receiptImageUrl: image?.fileObj,
        serialNumber: d.serialNumber,
        model: d.model,
        status: d.status,
        productType: d.productType,
        brand: d.brand
    }
    postAction(payload)
  }
  const onSubmitEdit = () => {
    putAction(createPayload)
  }
  const handleImport =()=>{
    const payload = {
      imageFile: image?.fileObj
    }
    postExcel(payload)
  }
  return (
    <PadContainer loading={getAllLoad || getProductsLoad}>
      <TitleContainer
        path={false}
        title="Device Management"
        className="border border-lit rounded-xl"
        action={<div className='flex'>
          <SearchPage setSearch={setSearch} size='large' />
          <Button onClick={onCreateOpen} className='!bg-light_blue mx-2' type='primary' size='large' icon={<FaPlus />}>Add Device</Button>
          <Button onClick={showModal} className='!bg-light_blue mx-2' type="primary" icon={<UploadOutlined />} size='large'>Import</Button>
          <Tooltip title="View Excel file sample">
            <a href="https://docs.google.com/spreadsheets/d/1l-EmbgsyYzCfnsW-Iew1-UgTOPhqkKo-w5asJyxNmq8/edit?usp=sharing" download>                
              <Button size='large'>Sample Template</Button>
            </a>
          </Tooltip>
        </div>
      }
      >
        <CustomTable
          pagination={10}
          column={columns}
          data={getAllData?.data?.data}
          rowSelection={handleTableSelect(rows, setRows, "_id")}
        />
      </TitleContainer>


      {/* create edit drawer */}
      <Drawer
        open={isCreateOpen}
        onClose={onCreateClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Insure New Device</p>}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmit}
          className='relative'
        >
          <div className='grid grid-cols-2 gap-2'>
            <Form.Item label="First Name" name="firstName">
              <Input size='large' placeholder='First Name' />
            </Form.Item>
            <Form.Item label="Last Name" name="lastName">
              <Input size='large' placeholder='Last Name' />
            </Form.Item>
          </div>
          <div className='grid grid-cols-2 gap-2'>
            <Form.Item label="Price" name="price">
              <Input size='large' placeholder='price...' />
            </Form.Item>
            <Form.Item label="Product Type" name="productType">
              <Select
                size='large' 
                placeholder='Select Product Type'
                onChange={(value)=> setProductType(value)}
            >
              {getProductsData?.data?.data.map((e)=>(
                <Select.Option value={e.name}>{e.name}</Select.Option>
              ))}
              </Select>
            </Form.Item>
          </div>
          {(productType?.toLowerCase() === "mobile" || productType?.toLowerCase() === "mobile phone") && (
            <div className='grid grid-cols-2 gap-2'>
              <Form.Item label="Imei Number 1" name="imeiNumber1">
                <Input size='large' placeholder='Imei Number 1' />
              </Form.Item>
              <Form.Item label="Imei Number 2" name="imeiNumber2">
                <Input size='large' placeholder='Imei Number 2' />
              </Form.Item>
            </div>
          )}
          <div className='grid grid-cols-2 gap-2'>
            <Form.Item label="Serial Number" name="serialNumber">
              <Input size='large' placeholder='Serial Number...' />
            </Form.Item>
            <Form.Item label="Model" name="model">
              <Input size='large' placeholder='Model' />
            </Form.Item>
          </div>
          <div className='grid grid-cols-2 gap-2'>
            <Form.Item label="Brand" name="brand">
              <Input size='large' placeholder='Brand' />
            </Form.Item>
            <Form.Item label="Status" name="status">
              <Select>
                <Select.Option value='Pending'>Pending</Select.Option>
                <Select.Option value='Active'>Active</Select.Option>
                <Select.Option value='Stolen'>Stolen</Select.Option>
                <Select.Option value='Lost'>Lost</Select.Option>
              </Select>
            </Form.Item>
          </div>
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCreateClose} loading={postLoad} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' loading={postLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Save</Button>
          </div>
        </Form>
      </Drawer>

      <Modal title="Upload Multiple devices"onCancel={() => setIsModalOpen(false)} open={isModalOpen} footer={false}>
        <Upload 
          {...uploadProps}
          accept=".xls, .xlsx">
          <Button block className='!bg-none text-secondary' icon={<LuFileUp className='text-light_blue' />} type='text' size='large'>Import Xlsx File</Button>
        </Upload>
        <Button loading={postExcelLoad} disabled={!image} onClick={()=>handleImport()} className='!bg-light_blue m-4' type="primary">
          Submit
        </Button>
      </Modal>

      <Drawer
        open={isOpenEdit}
        onClose={onCloseEdit}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Edit Device</p>}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmitEdit}
          className='relative'
        >
          <div className='grid grid-cols-2 gap-2'>
            <Form.Item label="First Name" name="firstName">
              <Input
                size='large'
                placeholder='First Name'
                value={createPayload.firstName}
                onChange={(e)=> setCreatePayload({...createPayload, firstName: e.target.value})}
              />
            </Form.Item>
            <Form.Item label="Last Name" name="lastName">
              <Input
                size='large'
                placeholder='Last Name'
                value={createPayload.lastName}
                onChange={(e)=> setCreatePayload({...createPayload, lastName: e.target.value})}
              />
            </Form.Item>
          </div>
          <div className='grid grid-cols-2 gap-2'>
            <Form.Item label="Price" name="price">
              <Input
                size='large'
                placeholder='price...'
                value={createPayload.price}
                onChange={(e)=> setCreatePayload({...createPayload, price: e.target.value})}
              />
            </Form.Item>
            <Form.Item label="Product Type" name="productType">
              <Select
                size='large' 
                placeholder='Select Product Type'
                value={createPayload.productType}
                onChange={(value)=> {
                  setProductType(value)
                  setCreatePayload({...createPayload, productType: value})
                }}
            >
              {getProductsData?.data?.data.map((e)=>(
                <Select.Option value={e.name}>{e.name}</Select.Option>
              ))}
              </Select>
            </Form.Item>
          </div>
          {(productType?.toLowerCase() === "mobile" || productType?.toLowerCase() === "mobile phone") && (
            <div className='grid grid-cols-2 gap-2'>
              <Form.Item label="Imei Number 1" name="imeiNumber1">
                <Input
                  size='large'
                  placeholder='Imei Number 1'
                  value={createPayload.imeiNumber1}
                  onChange={(e)=> setCreatePayload({...createPayload, imeiNumber1: e.target.value})}
                />
              </Form.Item>
              <Form.Item label="Imei Number 2" name="imeiNumber2">
                <Input
                  size='large'
                  placeholder='Imei Number 2'
                  value={createPayload.imeiNumber2}
                  onChange={(e)=> setCreatePayload({...createPayload, imeiNumber2: e.target.value})}
                />
              </Form.Item>
            </div>
          )}
          <div className='grid grid-cols-2 gap-2'>
            <Form.Item label="Serial Number" name="serialNumber">
              <Input
                size='large'
                placeholder='Serial Number...'
                value={createPayload.serialNumber}
                onChange={(e)=> setCreatePayload({...createPayload, serialNumber: e.target.value})}
              />
            </Form.Item>
            <Form.Item label="Model" name="model">
              <Input
                size='large'
                placeholder='Model'
                value={createPayload.model}
                onChange={(e)=> setCreatePayload({...createPayload, model: e.target.value})}
              />
            </Form.Item>
          </div>
          <div className='grid grid-cols-2 gap-2'>
            <Form.Item label="Brand" name="brand">
              <Input
                size='large'
                placeholder='Brand'
                value={createPayload.brand}
                onChange={(e)=> setCreatePayload({...createPayload, brand: e.target.value})}
              />
            </Form.Item>
            <Form.Item label="Status" name="status">
              <Select
                value={createPayload.status}
                onChange={(value)=> setCreatePayload({...createPayload, status: value})}
              >
                <Select.Option value='Pending'>Pending</Select.Option>
                <Select.Option value='Active'>Active</Select.Option>
                <Select.Option value='Stolen'>Stolen</Select.Option>
                <Select.Option value='Lost'>Lost</Select.Option>
              </Select>
            </Form.Item>
          </div>

          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCreateClose} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' loading={putLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Update</Button>
          </div>
        </Form>
      </Drawer>

      {/* view drawer */}
      <Drawer
        open={isViewOpen}
        onClose={onViewClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Brands</p>}
      >
        <div className='w-full'>
          <div className='flex gap-3 items-center'>
            <Image alt='Brands image' src={eventImage} />
            <div className='space-y-3'>
              <p className='text-2xl font-bold text-light_blue'>Kings’s Day Parade</p>
              <Tag className={`${statusType?.info?.bg} ${statusType?.secondary?.col} ${statusType?.info?.bd} font-bold rounded-2xl px-3 py-0.5`}>Active</Tag>
            </div>
          </div>
          <Divider />
          <div className='w-full rounded-xl bg-[#FEFAF2] px-5 divide-y'>
            {[
              {Icon: CiLocationOn, value: "Mandeville"},
              {Icon: ImStopwatch, value: "2pm"},
              {Icon: CiCalendarDate, value: "12 December, 2023"},
            ].map(({Icon, value}) => (
              <div className='flex items-center gap-3 py-5'>
                <Button className='!bg-[#FDE9C2] !text-[#F5A302]' icon={<Icon className="!text-xl" />} shape='circle' size='large' type='primary' />
                <p className='text-lg font-semibold text-silver'>{value}</p>
              </div>
            ))}
          </div>
          <Divider />
          <div className='w-full px-5 space-y-1'>
            {[
              {label: "Route From", value: "Lagos"},
              {label: "Route To", value: "Germany"},
              {label: "Category", value: "Music and Entertainment"},
              {label: "Created by", value: "Admin"},
            ].map(({label, value}) => (
              <div className='flex items-center gap-3'>
                <p className='text-base text-light_blue font-semibold'>{label}: </p>
                <p className='text-base text-dim font-medium'>{value}</p>
              </div>
            ))}
          </div>
          <Divider />
          <div className='w-full px-5 flex justify-between items-center'>
            <div className='flex items-center gap-5'>
              <p className='text-base text-light_blue font-semibold'>Attendees:</p>
              <Avatar.Group
                maxCount={4}
                maxPopoverTrigger="click"
                maxStyle={{ color: '#F5A302', backgroundColor: '#002C70', cursor: 'pointer' }}
              >
                {Array.from(Array(100).keys()).map(idx => (
                  <Avatar>{idx}</Avatar>
                ))}
              </Avatar.Group>
            </div>
            <Button className='!bg-lint text-dim' type='primary' size='small'>View All</Button>
          </div>
          <Divider />
          <div className='w-full px-5 space-y-1'>
            <p className='text-base text-light_blue font-semibold'>Description</p>
            <p className='text-sm text-dim font-normal'>Celebrate the vibrant spirit of our community at our annual Parade Spectacular! Join us for a lively and colourful procession weaving through the heart of [City/Town Name], featuring magnificent floats, marching bands, and dazzling performances.</p>
          </div>
          <Divider />
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={handleEdit} loading={false} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Edit</Button>
            <Button className='!text-light_blue !border-light_blue' size='large'>Delete</Button>
          </div>
        </div>
      </Drawer>
    </PadContainer>
  )
}

export default InsuredDevice